import { isAppTypeIframe } from "../getAppType";
import { CVPSearchParams } from "./wsQueryStringStore";

// when navigating redirect and getRedirectProps will use this function
// to filter out query params that are not relevant for the target path

// (if a parameter is not handled by this function then it is kept)
export function doesQueryParamBelongToPath(
  targetPath: string,
  key: CVPSearchParams
) {
  if (key === CVPSearchParams.cvpage && !isAppTypeIframe()) {
    return false;
  }

  if (key === CVPSearchParams.cvpr) {
    // keep id for these pages
    return ["jobs", "job", "apply", "applicationsent"].includes(targetPath);
  }

  if (key === CVPSearchParams.cvpt) {
    // keep id for these pages
    return ["jobs", "job", "apply", "applicationsent"].includes(targetPath);
  }

  if (key === CVPSearchParams.cvpmonth) {
    return ["workschedule"].includes(targetPath);
  }

  if (key === CVPSearchParams.cvpyear) {
    return ["workschedule"].includes(targetPath);
  }

  if (
    [
      CVPSearchParams.cvpfj,
      CVPSearchParams.cvpst,
      CVPSearchParams.cvppt,
      CVPSearchParams.cvpcat,
      CVPSearchParams.cvpct,
      CVPSearchParams.cvpmun,
      CVPSearchParams.cvpjo,
    ].includes(key)
  ) {
    // keep joblist filters for these pages
    return ["", "frontpage", "jobs", "job", "apply"].includes(targetPath);
  }

  if ([CVPSearchParams.cvpts, CVPSearchParams.cvpswt].includes(key)) {
    return targetPath === "timesheet";
  }

  if (
    [
      CVPSearchParams.cvpat,
      CVPSearchParams.cvptll,
      CVPSearchParams.cvptls,
      CVPSearchParams.cvpas,
    ].includes(key)
  ) {
    // keep only for admin page (deletes these when leaving admin page)
    return targetPath === "admin";
  }

  if (key === CVPSearchParams.cvpstep) {
    return targetPath === "questionnaire";
  }

  if (key === CVPSearchParams.cvpmsgid) {
    return targetPath === "messages";
  }

  if (key === CVPSearchParams.cvprb) {
    return false; // get rid of this one when navigating
  }

  if (key === CVPSearchParams.cvpuoq) {
    return targetPath === "useroverview";
  }

  if (
    [
      CVPSearchParams.cvpqap,
      CVPSearchParams.cvppou,
      CVPSearchParams.cvppot,
    ].includes(key)
  ) {
    return targetPath === "parameteroverride";
  }

  return true;
}
